import React from 'react';
import { IconBtn } from '../Button';

const DatatableMainInfo = ({
  icon = 'user',
  noIcon,
  title,
  subtitle,
  className: customClass,
  iconSize = 'sm',
  btnIconStyle = {},
  secondarySubtitle
}) => {
  return (
    <div className="datatable main-info">
      <div className={`main-info--icon ${customClass || ''}`}>
        {!noIcon && <IconBtn icon={icon} variant={`datatable ${btnIconStyle.color}`} iconSize={iconSize} />}
      </div>
      <div className="main-info--data">
        <p className="row-title">{title}</p>
        <p className="detail">{subtitle}</p>
        {secondarySubtitle && <p className="detail">{secondarySubtitle}</p>}
      </div>
    </div>
  );
};

export default DatatableMainInfo;
